import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import * as icons from '@gn-audio/icons';
import { JabraIcon, useJabraTheme } from '@gn-audio/jss-components';

import { IntroSectionItemProps } from 'components/Product/IntroSection/introSectionTypes';
import { useLinkAction } from 'utils/hooks/useLinkAction';

export const IntroSectionItem = ({
  title,
  icon,
  link,
  iconDropList,
  buttonAriaLabel,
}: IntroSectionItemProps) => {
  const { darkTheme } = useJabraTheme() || { darkTheme: true };
  const { href, linkOnClick } = useLinkAction(link);

  if (!link?.value) {
    return null;
  }

  const blockTitle = title?.value;
  const hasIcon = !!icon.value?.src;
  const hasIconDropListItem = !!iconDropList?.value;
  const renderIcon = hasIconDropListItem || hasIcon;

  const introSpotBlockBaseClasses = classNames(
    'flex h-full w-full flex-col items-center justify-start rounded-xl border border-black/5 bg-white bg-opacity-20 p-6 shadow-sm hover:no-underline'
  );
  const introSpotBlockLinkClasses = classNames(
    introSpotBlockBaseClasses,
    'hover:bg-opacity-40 transition-background duration-300 hover:shadow-md'
  );

  const content = (
    <>
      {renderIcon && (
        <div
          className={classNames(
            'mb-5 flex h-20 w-20 items-center justify-center rounded-full',
            hasIconDropListItem && (darkTheme ? 'bg-black/65' : 'bg-black/5')
          )}
        >
          {hasIconDropListItem ? (
            <JabraIcon
              className={classNames('h-10 w-10 filter')}
              Icon={icons[iconDropList?.value as keyof typeof icons]}
              style={{ fill: darkTheme ? 'white' : 'black' }}
            />
          ) : (
            hasIcon && (
              <Image
                className={classNames('h-10 w-10 filter', darkTheme && 'invert')}
                field={icon}
              />
            )
          )}
        </div>
      )}
      <h3
        className="text-center font-bold"
        dangerouslySetInnerHTML={{ __html: blockTitle as string }}
      />
    </>
  );

  return (
    <li className="w-full">
      {linkOnClick ? (
        <a
          href={href || '#'}
          onClick={(e) => {
            e.preventDefault();
            linkOnClick();
          }}
          {...(buttonAriaLabel?.value && { 'aria-label': buttonAriaLabel.value })}
          className={introSpotBlockLinkClasses}
        >
          {content}
        </a>
      ) : href ? (
        <a
          href={href}
          {...(buttonAriaLabel?.value && { 'aria-label': buttonAriaLabel.value })}
          className={introSpotBlockLinkClasses}
        >
          {content}
        </a>
      ) : (
        <div className={introSpotBlockBaseClasses}>{content}</div>
      )}
    </li>
  );
};
